// 3rd party packages from NPM
import 'bootstrap';
import 'owl.carousel';

var $navbar = $('.navbar'),
    $header = $('.header'),
    $scrollwrapper = $('.scroll-wrapper'),
    $scrollTop = $('#scrollTop');

var currScroll = $scrollwrapper.scrollTop();



function onScroll() {

    var navbarHeight = $navbar.outerHeight(),
        headerHeight = 0;
    
    if( $header.length ) headerHeight = $header.outerHeight();
    
    currScroll = $scrollwrapper.scrollTop();

    if( $('body').hasClass('transparent-navbar-over-header') ) {

        // if current scroll position is less than height of header -> make navbar transparent
        if( currScroll < headerHeight ) {
            $navbar.addClass('navbar--transparent');
        } else {
            $navbar.removeClass('navbar--transparent');
        }

        // if user is scrolling over header
        if( currScroll > navbarHeight && currScroll < headerHeight ) {
            $navbar.css('top', '-'+navbarHeight+'px'); // hide the navbar
        } else {
            $navbar.css('top', '0px'); // fix the navbar to the top
        }

        // add padding to allow for height of navbar
        //$header.css('padding-top', navbarHeight+'px');
    } 
    else {
        
        var resizeTimer;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {

            // add padding to allow for height of navbar
            $scrollwrapper.css('padding-top', navbarHeight+'px');

        }, 200);

    }

    if( currScroll > navbarHeight && currScroll > headerHeight ) {
        $navbar.addClass('navbar--shrink'); // shrink the navbar
    } else {
        $navbar.removeClass('navbar--shrink');
    }

    /*
     * Fade in/out Scroll Top button
     * scroll is below height of window, or scroll is 100px from bottom of page
     */
    if ( currScroll > $(window).height()/2 || currScroll > $('.scroll-wrapper')[0].scrollHeight-$(window).height()-100 ) {
        $scrollTop.addClass('visible');
    } else {
        $scrollTop.removeClass('visible');
    }

}


function scrollToTop() {

    $scrollTop.on('click', function() {
        $('.scroll-wrapper').animate({
            scrollTop: 0
        }, 800);
        return false;
    });

}


function carousels() {

    $(".owl-carousel").owlCarousel({
        items: 1,
        loop: true,
        margin: 0,
        responsiveClass: true,
        responsive: {
            0: { items: 1 },
            768: { items: 2 },
            992: { items: 3 }
        }
    });

}


function searchFormPlaceholder() {

    /**
     * Change search form placeholder text on home page
     */
    $('.search-form-home .form-control').attr('placeholder', 'Can\'t find what you\'re looking for? Search our Help & advice');

}


function helpSideMenu() {

    /**
     * Create duplicate Help side menu to show on mobile
     * ref: https://css-tricks.com/convert-menu-to-dropdown/
     */

    $("<select />").appendTo(".help-nav").addClass("form-control");

    $("<option />", {
        "selected": "selected",
        "value" : "",
        "text" : "- select -"
    }).appendTo(".help-nav select");

    $(".help-nav a").each(function() {
        var el = $(this);
        $("<option />", {
            "value"   : el.attr("href"),
            "text"    : el.text()
        }).appendTo(".help-nav select");
    });

    $(".help-nav select").change(function() {
        window.location = $(this).find("option:selected").val();
    });

}


function smoothScrollAnchors() {

    /*
     * Smooth scroll anchor links
     * ref: https://css-tricks.com/snippets/jquery/smooth-scrolling/
     */
    // Select all links with hashes
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
    .not('[href="#"]')
    .not('[href="#0"]')
    // Remove links that toggle collapse content
    .not('.toggle-link')
    .click(function(event) {
        // On-page links
        if (
            location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
            && 
            location.hostname == this.hostname
        ) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
                // Only prevent default if animation is actually gonna happen
                event.preventDefault();
                $('.scroll-wrapper').animate({
                    //scrollTop: target.offset().top
                    scrollTop: target.offset().top - $navbar.outerHeight() - 16
                }, 1000, function() {
                    // Callback after animation
                    // Must change focus!
                    var $target = $(target);
                    $target.focus();
                    if ($target.is(":focus")) { // Checking if the target was focused
                        return false;
                    } else {
                        //$target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                        $target.focus(); // Set focus again
                    };
                });
            }
        }
    });

}


function preventEmptySearches() {

    /**
     * Prevent empty searches
     */

    $.fn.preventEmptySubmit = function( options ) {
        var settings = {
            inputselector: "#s",
            msg : "Enter more than 3 characters!",
            minchars: 4
        };

        if ( options ) {
            $.extend( settings, options );
        };

        this.submit( function() {
            var s = $( this ).find( settings.inputselector );
                
            if ( ! s.val() || s.val().length < settings.minchars ) {
                alert( settings.msg );
                s.focus();
                return false;
            }
            return true;
        });
        return this;
    };

    $('#searchForm').preventEmptySubmit();

}


function googleMap() {

    /*
     * Google Maps for Advanced Custom Fields
     * ref: https://www.advancedcustomfields.com/resources/google-map/
     */
	
	/*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$el (jQuery element)
     *  @return	n/a
     */
	
	function new_map( $el ) {
		
		var $markers = $el.find('.marker');
		
		var args = {
			zoom		: 16,
			center		: new google.maps.LatLng(0, 0),
            mapTypeId	: google.maps.MapTypeId.ROADMAP, 
            scrollwheel : false
		};
		
		var map = new google.maps.Map( $el[0], args);
		
		map.markers = [];
		
		$markers.each(function(){
			add_marker( $(this), map );
		});
		
		center_map( map );
		
		return map;
	}
	
	/*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	$marker (jQuery element)
     *  @param	map (Google Map object)
     *  @return	n/a
     */
	
	function add_marker( $marker, map ) {
	
		var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
	
		var marker = new google.maps.Marker({
			position	: latlng,
			map			: map
		});
	
		map.markers.push( marker );
	
		if( $marker.html() ) {

			var infowindow = new google.maps.InfoWindow({
				content		: $marker.html()
			});
	
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open( map, marker );
			});
		}
	
	}
	
	/*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	4.3.0
     *
     *  @param	map (Google Map object)
     *  @return	n/a
     */
	
	function center_map( map ) {
	
		var bounds = new google.maps.LatLngBounds();
	
		$.each( map.markers, function( i, marker ){
	
			var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
	
			bounds.extend( latlng );
	
		});
	
		if( map.markers.length == 1 ) {
			map.setCenter( bounds.getCenter() );
			map.setZoom( 16 );
		} else {
			map.fitBounds( bounds );
		}
	
	}
	
	/*
     *  document ready
     *
     *  This function will render each map when the document is ready (page has loaded)
     *
     *  @type	function
     *  @date	8/11/2013
     *  @since	5.0.0
     *
     *  @param	n/a
     *  @return	n/a
     */
	// global var
	var map = null;
	
	$(document).ready(function(){
	
		$('.google-map-canvas').each(function(){
			map = new_map( $(this) );
		});
	
	});

}



jQuery(function () {


    if( $('body').hasClass('transparent-navbar-over-header') ) {
        $navbar.css('top', '-' + $navbar.outerHeight() + 'px');    
    }


    onScroll();
    scrollToTop();
    carousels();
    searchFormPlaceholder();
    helpSideMenu();
    smoothScrollAnchors();
    preventEmptySearches();
    googleMap();


    $(window).on('load resize', function(event) {
        onScroll();
    });
    $scrollwrapper.on('scroll', function(event) {
        onScroll();
    });


    // navbar mobile menu collapse
    $('.navbar-toggler').on('click', function() {
        $navbar.toggleClass('menu-open');
    });

    // expand hidden background panel
    $('.hiddenpanel-toggler').on('click', function() {
        $('body').toggleClass('hiddenpanel-open');
    });

    // close hidden background panel
    $('.hiddenpanel .close').on('click', function() {
        $('body').removeClass('hiddenpanel-open');
    });


});